import "/tmp/tmp-2315-JfZbkFQNxJYY/1a0145d978db/index.module.css";
export default {"pre":"index-module__pre___r1lXx","preNoWrap":"index-module__preNoWrap___Zh1tv"};